import { EventPayload } from '../../../core';

/**
 * Groups events by a step size in ms.
 * If an event is within the step size of the previous event, it will be grouped with it.
 * The metadata of the first event in the group will be used as the timestamp for the group.
 * NOTE: This function assumes that the events are sorted by timestamp.
 */
export function groupEvents(events: EventPayload[], stepSizeMs: number) {
  const groups = new Map<number, EventPayload[]>();
  // Keep track of the last timestamp to determine if we need to create a new group
  let lastTimestampMs = 0;
  // Our current group id;
  let eventGroupId = 0;

  for (const event of events) {
    // If the difference in time is greater than the step size, create a new group
    const differenceInTimeMs = Math.abs(event.timestampMs - lastTimestampMs);
    if (differenceInTimeMs > stepSizeMs) {
      eventGroupId++;
    }
    if (!groups.has(eventGroupId)) {
      groups.set(eventGroupId, []);
    }
    groups.get(eventGroupId)?.push(event);
    lastTimestampMs = event.timestampMs;
  }

  // Take the first and last event in each group and merge them into a single event
  const mergedEvents: EventPayload[] = Array.from(groups.values()).reduce((result, group) => {
    const firstEvent = group[0];
    const lastEvent = group[group.length - 1];

    if (group.length === 1 && firstEvent !== undefined) {
      result.push(firstEvent);
    } else if (firstEvent !== undefined && lastEvent !== undefined) {
      result.push({
        ...firstEvent,
        timestampMs: firstEvent.timestampMs,
        endTimestampMs: lastEvent.timestampMs,
      });
    }
    return result;
  }, [] as EventPayload[]);

  return mergedEvents;
}
